import { useTranslation } from "@redotech/redo-i18n";
import type { IsRepairState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const IsRepairDetails = memo(function IsRepairDetails({
  disabled,
}: ConditionTypeDetailsProps<IsRepairState>) {
  const { t } = useTranslation();
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        {t("Condition")}
      </Text>
      <Text fontSize="xxs" fontWeight="regular" textColor="secondary">
        {t("Applies when the return is marked as a repair.")}
      </Text>
    </Flex>
  );
});
